/**
 * Notificaciones nativas del navegador (Notification API) para los avisos
 * de Compras que llegan por socket.io en tiempo real. Todo es best-effort:
 * si el navegador no soporta la API, o el usuario nunca dio permiso, o lo
 * negó, simplemente no se muestra nada — el usuario igual ve el aviso en la
 * campana del header.
 */

export const soportaNotificacionesNavegador = () =>
    typeof window !== "undefined" && "Notification" in window;

/**
 * Pide permiso solo si el usuario nunca respondió ("default"). Si ya lo
 * concedió o lo negó antes, no vuelve a preguntar (el navegador tampoco lo
 * permitiría).
 */
export const solicitarPermisoNotificaciones = () => {
    if (!soportaNotificacionesNavegador()) return;
    if (Notification.permission === "default") {
        Notification.requestPermission().catch(() => { });
    }
};

/**
 * Muestra una notificación nativa si el permiso está concedido.
 * `onClick` recibe el foco de vuelta a la pestaña y navega al detalle.
 */
export const mostrarNotificacionNavegador = (titulo, { body, icon, onClick } = {}) => {
    if (!soportaNotificacionesNavegador() || Notification.permission !== "granted") return;
    try {
        const notificacion = new Notification(titulo, { body, icon, tag: `compras-${Date.now()}` });
        notificacion.onclick = () => {
            window.focus();
            notificacion.close();
            if (onClick) onClick();
        };
        // Se autocierra para no acumular notificaciones viejas en la bandeja del SO.
        setTimeout(() => notificacion.close(), 10000);
        return notificacion;
    } catch (error) {
        // Algunos navegadores (ej. móviles) no soportan `new Notification(...)`
        // aunque expongan el objeto global — no debe romper la app.
    }
};
